export default {
  "b2b.produkty-grid.title": "Products",
  "b2b.produkty-grid.add": "Add product"
};
